// shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from './modules/material.module';
import { ProgressCircleComponent } from '../@Assessment/progress-circle/progress-circle.component';

import { HeaderComponent } from './header/header.component';
import { AgGridCustomizedCellComponent } from './ag-grid-customized-cell/ag-grid-customized-cell.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    AgGridCustomizedCellComponent,
    ProgressCircleComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MaterialModule
  ],
  exports: [
    HeaderComponent,
    AgGridCustomizedCellComponent,
    ProgressCircleComponent,
    ConfirmDialogComponent,
  ]
})
export class SharedModule {}
